const addUser = (data) => {
    return {
        type: "ADD_USER_DATA",
        data
    }
}

export { addUser }